import { useQuery } from '@tanstack/react-query'
import {
  FETCH_BAND_BANNER_DATA_QUERY,
  FETCH_PLUS_PRICING_FAQ_NEW_QUERY,
  FETCH_PLUS_PRICING_HERO_NEW_QUERY,
  FETCH_PORTAL_HOME_ACTIVITY_PROMOTION_BANNER_NEW_DATA,
  MKT_GNB_EVENT_MENU,
  MKT_GNB_EVENT_MENU_NEW,
  MKT_PORTAL_HOME_TOP_BAR_MENU_DATA,
} from '../../../sanity/groqQueries'
import client from '../../sanityClient'

const fetchWebviewHomePromotionBanner = async () => {
  try {
    const response = await client.fetch(FETCH_PORTAL_HOME_ACTIVITY_PROMOTION_BANNER_NEW_DATA)
    return response
  } catch (error) {
    console.error('Failed to fetch data:', error)
    throw error
  }
}

export const useWebviewHomePromotionBanner = (config = {}) => {
  return useQuery({
    queryKey: ['portalHomePromotionBanner'],
    queryFn: fetchWebviewHomePromotionBanner,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...config,
  })
}

const fetchBandBannerData = async () => {
  try {
    const response = await client.fetch(FETCH_BAND_BANNER_DATA_QUERY)
    return response
  } catch (error) {
    console.error('Failed to fetch data:', error)
    throw error
  }
}

export const useBandBannerData = (config = {}) => {
  return useQuery({
    queryKey: ['bandBannerNewData'],
    queryFn: fetchBandBannerData,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...config,
  })
}

const fetchGnbData = async () => {
  const data = await client.fetch(MKT_GNB_EVENT_MENU)
  return data
}

export const useEventGnbDate = (config = {}) => {
  return useQuery({
    queryKey: ['mktGnbMenu_EventGnbData'],
    queryFn: () => fetchGnbData(),
    staleTime: 1000 * 60 * 60 * 24,
    cacheTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...config,
  })
}
const fetchGnbDataNew = async () => {
  const data = await client.fetch(MKT_GNB_EVENT_MENU_NEW)
  return data
}

export const useEventGnbDateNew = (config = {}) => {
  return useQuery({
    queryKey: ['mktGnbMenu_EventGnbData_New'],
    queryFn: () => fetchGnbDataNew(),
    staleTime: 1000 * 60 * 60 * 24,
    cacheTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...config,
  })
}

const fetchPortalHomeTopBarMenuData = async () => {
  try {
    const data = await client.fetch(MKT_PORTAL_HOME_TOP_BAR_MENU_DATA)
    return data
  } catch (error) {
    console.error('Failed to fetch data:', error)
    throw error
  }
}

export const usePortalHomeTopBarMenuData = (config = {}) => {
  return useQuery({
    queryKey: ['portalHomeTopBarMenuData'],
    queryFn: fetchPortalHomeTopBarMenuData,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...config,
  })
}

const fetchPricingHeroData = async () => {
  try {
    const response = await client.fetch(FETCH_PLUS_PRICING_HERO_NEW_QUERY)
    return response
  } catch (error) {
    console.error('Failed to fetch data:', error)
    throw error
  }
}

export const usePricingHeroData = (config = {}) => {
  return useQuery({
    queryKey: ['pricingHeroNew'],
    queryFn: fetchPricingHeroData,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...config,
  })
}

export const CUSTOMER_TYPE_SLUGS = {
  B2C_COMBINED_WITH_ONE_ON_ONE: 'b2c-combinedWithOneOnOne',
  B2C_AI_TUTOR: 'b2c-aiTutor',
  B2B2C_COMBINED_WITH_ONE_ON_ONE: 'b2b2c-combinedWithOneOnOne',
  B2B2C_AI_TUTOR: 'b2b2c-aiTutor',
  B2B_HR_COMBINED_WITH_ONE_ON_ONE: 'B2B_HR-combinedWithOneOnOne',
  B2B_HR_AI_TUTOR: 'B2B_HR-aiTutor',
} as const

export type CustomerTypeSlug = (typeof CUSTOMER_TYPE_SLUGS)[keyof typeof CUSTOMER_TYPE_SLUGS]

const fetchPricingFAQData = async (slug) => {
  try {
    const response = await client.fetch(FETCH_PLUS_PRICING_FAQ_NEW_QUERY, { slug: slug })
    return response
  } catch (error) {
    console.error('Failed to fetch data:', error)
    throw error
  }
}

export const usePricingFAQData = (slug: CustomerTypeSlug, config = {}) => {
  return useQuery({
    queryKey: ['pricing_faq_data', slug],
    queryFn: () => fetchPricingFAQData(slug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...config,
  })
}
